import { memo, type PropsWithChildren } from 'react';

import { ProgressDashes } from '~/components/ProgressDashes';
import { AirLogo } from '~/components/v2/components/shared/branding/AirLogo';

export type WorkspaceOnboardingCardLayoutProps = PropsWithChildren<{
  currentStep: number;
  totalSteps: number;
}>;

export const WorkspaceOnboardingCardLayout = memo(
  ({ children, currentStep, totalSteps }: WorkspaceOnboardingCardLayoutProps) => {
    return (
      <div className="flex h-full overflow-hidden">
        {/* bg-[#007BE9] is color-matched to the sky video to avoid a flash while it loads */}
        <div className="relative hidden max-h-full shrink-0 overflow-hidden bg-[#007BE9] md:block md:w-[270px] lg:w-[370px]">
          <video
            autoPlay
            loop
            muted
            playsInline
            tabIndex={-1}
            aria-hidden="true"
            className="h-full w-full object-cover"
          >
            <source src="/images/loopingsky.webm" type="video/webm" />
            <source src="/images/loopingsky.mp4" type="video/mp4" />
          </video>
        </div>

        <div className="flex min-h-0 w-full flex-col justify-between gap-4 p-4">
          <div className="flex min-h-0 flex-1 flex-col gap-8 overflow-y-auto px-9 pt-16">
            <AirLogo className="h-8 w-18" aria-hidden="true" />
            {children}
          </div>

          <div className="flex justify-center">
            <ProgressDashes totalSteps={totalSteps} currentStep={currentStep} />
          </div>
        </div>
      </div>
    );
  },
);

WorkspaceOnboardingCardLayout.displayName = 'WorkspaceOnboardingCardLayout';
